<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div v-if="paymentDetails.selectScreen && paymentOption === ''" class="modal-container modal-container-40"
          style="overflow-y: auto;" :style="{maxHeight: getMaxHeightClient() + 'px'}"
          @mousedown.stop="">
          <div class="modal-body m-0 p-0">
            <div class="panel21">
              <div class="row">
                <div class="col-md-4">
                  <button round class="button-action firstButtonMarginTop milkyBlockBlack"
                    @click="selectPaymentOption('normal')">
                    Paiement par virement
                  </button>
                </div>
                <div class="col-md-4">
                  <button round class="button-action firstButtonMarginTop milkyBlockBlack"
                    @click="selectPaymentOption('CB')">
                    Paiement par carte bleue
                  </button>
                </div>
                <div class="col-md-4">
                  <button round class="button-action firstButtonMarginTop milkyBlockBlack"
                    @click="selectPaymentOption('SCTInst')">
                    Paiement par instantané
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="paymentOption !== ''" class="modal-container modal-container-80" style="overflow-y: auto;"
          :style="{maxHeight: getMaxHeightClient() + 'px'}"
          @mousedown.stop="">
          <div class="modal-body m-0 p-0">
            <page-axepta v-if="paymentOption === 'CB'" :refNr="paymentDetails.ref" :transId="paymentDetails.transId" :amount="paymentDetails.amount" :currency="paymentDetails.currency" :orderDesc="paymentDetails.description" :height="700"></page-axepta>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import PageAxepta from '@/pages/axepta/PageAxepta.vue'

export default {
  name: 'PopupPaymentAxepta',
  components: {
    'page-axepta': PageAxepta
  },
  props: {
    paymentDetails: {
      type: Object
    }
  },
  data () {
    return {
      paymentOption: ''
    }
  },
  watch: {
    paymentOption (val) {
      console.log(val)
      if (val !== '' && val !== 'CB') {
        this.$emit('close')
      }
    }
  },
  created () {
    let that = this
    window.addEventListener('resize', this.changeMaxHeightClient)
    window.addEventListener('message', (event) => {
      if (event.origin === 'https://axepta.dev.moneyroad.streammind.com') {
        setTimeout(function () {
          that.$emit('close')
          that.$bus.$emit('pay-transaction')
        }, 3000)
      } else if (window.location.href.includes(event.origin)) {
        that.$emit('close')
      }
    }, false)
  },
  destroyed () {
    window.removeEventListener('resize', this.changeMaxHeightClient)
  },
  methods: {
    changeMaxHeightClient () {
      let maxHeight = document.querySelector('body').clientHeight - 50
      document.querySelector('.modal-container').setAttribute('style', 'overflow-y:auto;max-height:' + maxHeight + 'px')
    },
    getMaxHeightClient () {
      return document.querySelector('body').clientHeight - 50
    },
    selectPaymentOption (paymentOption) {
      this.paymentOption = paymentOption
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// CMPaymentAxepta.vue?70c7ffec